import React, { useState, useEffect } from 'react'
import Button from '../../../1_Atoms/Button/Button';
import Input from '../../../1_Atoms/Forms/Input/Input';
import { Svg } from '../../../1_Atoms/Svg/Svg';
import formValidationController from '../../../../controllers/formValidationController';
import { languageController } from '../../../../controllers/language/languageController';
import { pushToGTMDataLayer } from '../../../../utils/helpers';

interface StatusMessage {
  text: string;
  isError: boolean;
}

interface DealerSearchProps {
  onSubmit: (dealerValue: string, postalValue: string) => void;
  onGeolocationSubmit: () => void;
  initPostalKeyword?: string | null;
  statusMessage: StatusMessage;
  errorMessage: string;
}

const DealerSearch: React.FC<DealerSearchProps> = ({
  onSubmit,
  onGeolocationSubmit,
  // initDealerKeyword,
  initPostalKeyword,
  statusMessage,
  errorMessage
}) => {
  const [dealerKeyword, setDealerKeyword] = useState<string>('')
  const [postalKeyword, setPostalKeyword] = useState<string>('')
  const [postalErrorMessage, setPostalErrorMessage] = useState<string>('')

  // useEffect(() => {
  //   if (initDealerKeyword) {
  //     setDealerKeyword(initDealerKeyword)
  //   }
  // }, [initDealerKeyword])

   useEffect(() => {
    if (initPostalKeyword) {
      setPostalKeyword(initPostalKeyword)
    }
  }, [initPostalKeyword])

  return (
    <div className={`mz-dealer-search ${statusMessage.text ? 'status-message-active' : ''}`}>
      <div className="mz-container">
        <div className="mz-dealer-search__inner mz-full-width grid-inner-2-10-md grid-inner-2-10-lg">

          <form 
            className="mz-dealer__input"
            onSubmit={(e) =>{
              e.preventDefault();
              if (formValidationController.validateField(postalKeyword, 'postalcode') || dealerKeyword.length > 0) {  
                if (postalErrorMessage) setPostalErrorMessage('');            
                onSubmit(dealerKeyword, postalKeyword);
              }else{
                setPostalErrorMessage(languageController.getError('postalcode') || '')
              }
              pushToGTMDataLayer({ event: 'Dealer Search', dealer: dealerKeyword, postalcode: postalKeyword });
            }}
          >
              <Input
                type="text"
                name="dealer"
                label={languageController.getCopy('findDealer', 'searchInput')}
                value={dealerKeyword}
                onChange={(e) => setDealerKeyword(e.target.value)}
                maxLength={50}
                extraClass="mz-form-item-preferred-retailer"
              />
              <div className="text--grey mz-form-item--or">{languageController.getCopy('findDealer', 'or')}</div> 
              <Input
                type="text"
                name="postal"
                label={languageController.getFormCopy('label', 'postalcode')}
                value={postalKeyword}
                onChange={(e) => setPostalKeyword(e.target.value)}
                errorMessage={postalErrorMessage}
                maxLength={7}
                extraClass="mz-form-item-postal-code"
              />
              <Button
                type="submit"
                className="mz-btn--primary"
                label={languageController.getCopy('findDealer', 'searchSubmit')}
                data-menu-name="Dealer Search"
                data-form-name="Find a dealer"
                data-form-event="Search dealers"
              />
              {
                errorMessage && (
                  <div className="mz-dealer-search__error-message">{errorMessage}</div>
                )
              }
          </form>

          <hr className="mz-dealer__hr"></hr>
          {/*<p className="text--grey paragraph">{languageController.getCopy('findDealer', 'or')}</p>-->*/}

          <Button
            className="mz-btn--primary mz-dealer__giolocation-btn"
            label={languageController.getCopy('findDealer', 'useGeolocation')}
            onClick={onGeolocationSubmit}
            buttonIcon={<Svg type="locationairplane" size={1.2} colour="white" style={{ top: '1px' }} />}
            buttonIconPosition="right"
            data-menu-name="Geolocation Search"
            data-form-name="Find a dealer"
            data-form-event="Use current location"
          />

          <div className={`mz-dealer-search__status-message ${statusMessage.text ? 'active' : ''}`}>
            <Svg type={statusMessage.isError ? 'warning' : 'sync'} size={1} colour="black" style={{ top: '1px' }} />
            <span className="interactive">{statusMessage.text}</span>
          </div>

        </div>
      </div>
    </div>
  )
}

export default DealerSearch
